<template>
  <div>
    <v-form>
      <v-layout row wrap>
      </v-layout>


      <v-dialog v-model="val.Dialog" persistent max-width="1000px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont"> {{$t('Invoice-Entry')}} </v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                <div class="flex md4">
                  <div class="card card--tile ">
                    <div class="card__text grey darken-1 white--text">
                      <h3>{{ $t('General-Information') }}</h3>
                    </div>
                  </div>

                  <tarihim :etiket="$t('Invoice-Date')" v-bind:defaultvalue="'ok'" v-bind:value="val.Fatura.FaturaTarih"
                    v-model="val.Fatura.FaturaTarih"></tarihim>

                  <v-layout>
                    <v-text-field hide-details="" v-model="val.Fatura.FaturaSeri" :label="$t('Invoice-Serial')"></v-text-field>

                    <v-text-field hide-details="" :label="$t('Invoice-No')" v-model="val.Fatura.FaturaNo"></v-text-field>
                  </v-layout>
                  <v-select :items="gibseri" tabindex="26" v-model="val.Fatura.GibSeri" hide-details="" clearable
                    item-text="Seri" item-value="Seri" :label="$t('Turkish-Revenue-Administration-Serial-No')"></v-select>
                  <v-text-field hide-details="" :label="$t('Title_label') + '1'" v-model="val.Fatura.EFaturaBilgi.Unvani"></v-text-field>
                  <v-text-field hide-details="" :label="$t('Title_label') + '2'" v-model="val.Fatura.EFaturaBilgi.Unvani2">
                  </v-text-field>
                  <v-text-field hide-details="" :label="$t('Address_label') + '1'" v-model="val.Fatura.EFaturaBilgi.Adres1"></v-text-field>
                  <v-text-field hide-details="" :label="$t('Address_label') + '2'" v-model="val.Fatura.EFaturaBilgi.Adres2"></v-text-field>
                  <v-text-field hide-details="" :label="$t('Province_label')" v-model="val.Fatura.EFaturaBilgi.IlceSehir">
                  </v-text-field>
                  <v-text-field hide-details="" :label="$t('Invoice-E-mail')" v-model="val.Fatura.EFaturaBilgi.Email">
                  </v-text-field>
                  <v-text-field hide-details="" :label="$t('Taxcenter_label')" v-model="val.Fatura.EFaturaBilgi.VergiDairesi">
                  </v-text-field>
                  <v-text-field hide-details="" :label="$t('Taxnumber_label')" v-model="val.Fatura.EFaturaBilgi.VergiNo">
                  </v-text-field>
                  <v-text-field hide-details="" :label="$t('Identitynumber_label')" v-model="val.Fatura.EFaturaBilgi.TcKimlikNo">
                  </v-text-field>
                </div>

                <div class="flex md4">
                  <div class="card card--tile ">
                    <div class="card__text grey darken-1 white--text">
                      <h3>{{$t('Foridentity_header')}}</h3>
                    </div>
                  </div>

                  <v-text-field hide-details="" maxlength="50" v-model="val.Fatura.EFaturaBilgi.Adi" :label="$t('Name_label')"></v-text-field>
                  <v-text-field hide-details="" maxlength="50" v-model="val.Fatura.EFaturaBilgi.Soyadi" :label="$t('Surname_label')">
                  </v-text-field>
                  <v-text-field hide-details="" maxlength="50" v-model="val.Fatura.EFaturaBilgi.TUnvani" :label="$t('Title_label')">
                  </v-text-field>
                  <v-text-field hide-details="" maxlength="50" v-model="val.Fatura.EFaturaBilgi.DigerAdi" :label="$t('Othername_label')">
                  </v-text-field>
                  <v-text-field hide-details="" maxlength="50" v-model="val.Fatura.EFaturaBilgi.OnAdiEki" :label="$t('Suffixname_label')">
                  </v-text-field>
                  <div class="card card--tile ">
                    <div class="card__text grey darken-1 white--text">
                      <h3>Dizayn Seçenekler</h3>
                    </div>
                  </div>

                  <v-checkbox @change="dizayngetir()" :label="$t('Print-Invoice-with-Currency')"
                    v-model="val.Fatura.Opsiyonlar.DovizliFatura" hide-details></v-checkbox>
                  <v-select :items="dizaynsec" @change="xsltsec(val.Fatura.FaturaBilgi.FaturaID)"
                    v-model="val.Fatura.FaturaBilgi.FaturaID" tabindex="26" hide-details="" clearable
                    item-text="FaturaAciklama" item-value="FaturaId" :label="$t('Select-Design')"></v-select>
                  <reportbrosablon v-show="false" ref="reportbrosablon" v-model="val.Fatura.FaturaBilgi.FaturaPdfID"
                    dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
                </div>

                <div class="flex md4">
                  <div class="card card--tile ">
                    <div class="card__text grey darken-1 white--text">
                      <h3>{{ $t('Options-v2') }}</h3>
                    </div>
                  </div>
                  <v-checkbox :label="$t('Change-Title-and-Address-Information')" hide-details></v-checkbox>
                  <v-checkbox :label="$t('Do-Not-Print-Passenger-Name')" v-model="val.Fatura.Opsiyonlar.YolcuGosterme" hide-details>
                  </v-checkbox>
                  <v-checkbox :label="$t('Do-Not-Print-Payment-Term')" hide-details></v-checkbox>
                  <v-checkbox :label="$t('Do-Not-Print-Discount')" hide-details></v-checkbox>
                  <v-checkbox :label="$t('Print-Total-and-Currency-Invoice')" hide-details></v-checkbox>
                  <v-checkbox :label="$t('Calculate-VAT-Tax-Base-Total')" hide-details></v-checkbox>
                  <v-checkbox :label="$t('Reprinting-Invoice')" hide-details></v-checkbox>
                  <v-checkbox :label="$t('Print-Invoice-Details')" v-model="val.Fatura.Opsiyonlar.FaturaDetayBas" hide-details>
                  </v-checkbox>
                </div>
                <div class="flex md12">
                  <v-text-field hide-details="" v-model="val.Fatura.FaturaBilgi.FaturaDipAciklama"
                    :label="$t('E-invoice-Footer-Disclosure')"></v-text-field>
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" flat @click.native="val.Dialog=false">{{$t('Cancel')}}</v-btn>
            <div>
              <v-btn id="bkaydet" color="blue darken-1" flat @click="faturakaydet()">{{$t('Invoice')}}</v-btn>
            </div>

          </v-card-actions>
        </v-card>
      </v-dialog>
      <loadingcomp ref="loadingcomp" v-bind:mesaj="''" v-model="loadingdialog"></loadingcomp>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>


    </v-form>
  </div>
</template>

<script>
  import parainput from '@/components/app/customcomp/parainput.vue'
  import tarihim from "@/components/app/customcomp/tarihim.vue"
  import auth from '../../../../api/auth'
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
  import helpers from "@/components/app/customcomp/helpers.js"
  import onaydialog from "@/components/app/customcomp/onaydialog.vue"
  import loadingcomp from "@/components/app/customcomp/loadingcomp.vue"


  export default {
    props: ["value"],

    computed: {
      val: {
        get: function () {

          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    data() {
      return {
        loadingdialog: false,
        mesaj: null,
        dizaynsec: [],
        gibseri: [],
        text1: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {
      'val.Dialog': function (val) {
        if (val == true) {

          var credentials = JSON.parse(window.localStorage.getItem('credentials'));

          var CurrentInput = {
            Code: this.val.Fatura.BiletBilgi.CariKod.Kod,
            CompanyCode: credentials.SirketKodu
          }
          this.$http.post(auth.API_URL + 'api/Current/Get', CurrentInput, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {


            this.val.Fatura.EFaturaBilgi.Unvani = response.body.Title
            this.val.Fatura.EFaturaBilgi.Adres1 = response.body.Invoice.Address
            this.val.Fatura.EFaturaBilgi.IlceSehir = response.body.Invoice.Province
            this.val.Fatura.EFaturaBilgi.Email = response.body.Email
            this.val.Fatura.EFaturaBilgi.VergiDairesi = response.body.Invoice.TaxOffice
            this.val.Fatura.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber
            this.val.Fatura.EFaturaBilgi.TcKimlikNo = response.body.Invoice.IdentityNumber
            this.val.Fatura.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName
            this.val.Fatura.EFaturaBilgi.Soyadi = response.body.Invoice.PerFamilyName
            this.val.Fatura.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle
            this.val.Fatura.EFaturaBilgi.DigerAdi = response.body.Invoice.PerMiddleName
            this.val.Fatura.EFaturaBilgi.OnAdiEki = response.body.Invoice.PerNameSuffix


            //0 ise Earşiv / 1 ise gib seri

            if (response.body.EInvoiceCustomer == 1) {

              var params1 = {
                CompanyCode: credentials.SirketKodu,
              PassiveControl: true,
              }

              this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {
                this.gibseri = response.body
              }, (response) => {
                if (response.status === 0) {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                } else {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                }
              })

            }

            if (response.body.EInvoiceCustomer == 0) {

              var params1 = {
                CompanyCode: credentials.SirketKodu,
              PassiveControl: true,
              }
              this.$http.post(auth.API_URL + 'api/Definitions/GibSerialEarchiveList', params1, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {
                this.gibseri = response.body
              }, (response) => {
                if (response.status === 0) {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                } else {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                }
              })


            }

            this.dizayngetir();


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = response.body.StatusText
              this.snackbar = true
            }
          })

        }
      },

    },
    methods: {
      xsltsec(Faturaid) {
        this.dizaynsec.forEach(element => {
          if (element.FaturaId == Faturaid) {
            this.val.Fatura.FaturaBilgi.FaturaXSLTID = element.FaturaXsltId
            this.val.Fatura.FaturaBilgi.FaturaPdfID = element.FaturaPdfID
          }
        });
      },
      dizayngetir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var hattipi = null

        if (this.val.UcusTipi == 'I') {
          hattipi = false
        } else {
          hattipi = true
        }

        var params = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: this.val.Fatura.FaturaBilgi.FaturaTip,
          DovizliFatura: this.val.Fatura.Opsiyonlar.DovizliFatura,
          HatTipi: hattipi,
          TumFiltre: true
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynsec = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceMainTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceMainTableList'
            this.snackbar = true
          }
        })

      },
      faturakaydet() {


        if (this.val.Fatura.BiletBilgi.ServisTutar > 0) {

          if (this.val.Fatura.FaturaTarih != null && this.val.Fatura.FaturaTarih != '') {

            if (this.val.Fatura.FaturaSeri != null && this.val.Fatura.FaturaSeri != '') {

              if (this.val.Fatura.FaturaNo != null && this.val.Fatura.FaturaNo != '') {

                if (this.val.Fatura.FaturaBilgi.FaturaID != null && this.val.Fatura.FaturaBilgi.FaturaID != '' && this
                  .val.Fatura.FaturaBilgi.FaturaID != 0) {

                  if (this.val.Fatura.GibSeri != null && this.val.Fatura.GibSeri != '') {

                    var paramsfatura = this.val.Fatura

                    this.loadingdialog = true

                    this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceRefundAdd', paramsfatura, {
                      headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                      }
                    }).then((response) => {

                      if (response.body.FaturaStatus == true) {
                        this.loadingdialog = false

                        this.val.Dialog = false

                        this.text1 = response.body.FaturaResponse
                        this.snackbar = true

                        // var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +
                        //   '&biletno=' +
                        //   this.Bilet.GenelBilgileri.BiletNo + '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi +
                        //   '&tab=0'
                        // window.open(url, '_self')

                        // setTimeout(function () {
                        //   window.location.reload(false);
                        // }.bind(this), 3000)

                      } else {
                        this.text1 = response.body.FaturaResponse
                        this.snackbar = true
                        this.loadingdialog = false

                      }
                    }, (response) => {
                      if (response.status === 0) {
                        this.loadingdialog = false

                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                      } else {
                        this.loadingdialog = false

                        this.text1 = response.body.StatusText
                        this.snackbar = true
                      }
                    })

                  } else {
                    this.text1 = this.$t('Please-choose-a-gib-series')
                    this.snackbar = true
                  }
                } else {
                  this.text1 = this.$t('Please-choose-invoice-design')
                  this.snackbar = true
                }
              } else {
                this.text1 = this.$t('Please-enter-invoice-no')
                this.snackbar = true
              }
            } else {
              this.text1 = this.$t('Please-enter-invoice-serial')
              this.snackbar = true
            }

          } else {
            this.text1 = this.$t('Please-enter-invoice-date')
            this.snackbar = true
          }
        } else {
          this.text1 = this.$t('Service-amount-must-greater-than')
          this.snackbar = true
        }

      }

    },
    components: {
      reportbrosablon,
      tarihim,
      parainput,
      loadingcomp
    }

  }
</script>